/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Code_LabelInputs */

const en_login_page_code_label = /** @type {(inputs: Login_Page_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification code`)
};

const de_login_page_code_label = /** @type {(inputs: Login_Page_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungscode`)
};

const pt_br2_login_page_code_label = /** @type {(inputs: Login_Page_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de verificação`)
};

const tr_login_page_code_label = /** @type {(inputs: Login_Page_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrulama kodu`)
};

const zh_cn2_login_page_code_label = /** @type {(inputs: Login_Page_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证码`)
};

const zh_hk2_login_page_code_label = /** @type {(inputs: Login_Page_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證碼`)
};

const ko_kr2_login_page_code_label = /** @type {(inputs: Login_Page_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증 코드`)
};

const ru_ru2_login_page_code_label = /** @type {(inputs: Login_Page_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код подтверждения`)
};

const es_419_login_page_code_label = /** @type {(inputs: Login_Page_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de verificación`)
};

/**
* | output |
* | --- |
* | "Verification code" |
*
* @param {Login_Page_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_code_label = /** @type {((inputs?: Login_Page_Code_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Code_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_code_label(inputs)
	if (locale === "de") return de_login_page_code_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_code_label(inputs)
	if (locale === "tr") return tr_login_page_code_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_code_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_code_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_code_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_code_label(inputs)
	return es_419_login_page_code_label(inputs)
});